import { APP_URL, MARKETING_URL, STATUS_URL } from '@/lib/config'

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <span>© {new Date().getFullYear()} Scrambl</span>
      <nav aria-label="Footer">
        <a href={MARKETING_URL}>scrambl.com</a>
        <a href={APP_URL}>Open app</a>
        <a href={STATUS_URL}>Status</a>
        <a href="mailto:support@scrambl.com">support@scrambl.com</a>
      </nav>
    </footer>
  )
}
